import EnvironmentalStatusBadge from "./EnvironmentalStatusBadge";

interface ConservationUnitCardProps {
  item: {
    id: string;
    nome: string;
    categoria: string;
    grupo: string;
    municipio: string;
    uf: string;
    areaHa: number;
    instrumentoLegal: string;
    temPlanoManejo: boolean;
    arvoresCadastradas: number;
    areasDegradadas: number;
    co2eEstimado: number;
    statusGestao: string;
    orgaoGestor: string;
  };
  onViewDetail: (item: any) => void;
}

export default function ConservationUnitCard({ item, onViewDetail }: ConservationUnitCardProps) {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 hover:border-background-300/60 transition-all duration-200 p-5 group cursor-pointer" onClick={() => onViewDetail(item)}>
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-foreground-900 font-heading truncate">{item.nome}</h4>
          <p className="text-xs text-foreground-500 mt-0.5">{item.categoria} · {item.grupo}</p>
        </div>
        <EnvironmentalStatusBadge status={item.statusGestao} />
      </div>

      <div className="grid grid-cols-2 gap-2 mb-3">
        <div className="bg-background-50 rounded-lg p-2.5">
          <p className="text-[10px] text-foreground-500 uppercase tracking-wide">Área</p>
          <p className="text-sm font-semibold text-foreground-900">{item.areaHa} ha</p>
        </div>
        <div className="bg-background-50 rounded-lg p-2.5">
          <p className="text-[10px] text-foreground-500 uppercase tracking-wide">Árvores CTA</p>
          <p className="text-sm font-semibold text-foreground-900">{item.arvoresCadastradas}</p>
        </div>
        <div className="bg-background-50 rounded-lg p-2.5">
          <p className="text-[10px] text-foreground-500 uppercase tracking-wide">Área Degradada</p>
          <p className={`text-sm font-semibold ${item.areasDegradadas > 10 ? "text-danger-600" : "text-foreground-900"}`}>{item.areasDegradadas} ha</p>
        </div>
        <div className="bg-background-50 rounded-lg p-2.5">
          <p className="text-[10px] text-foreground-500 uppercase tracking-wide">CO₂e Est.</p>
          <p className="text-sm font-semibold text-foreground-900">{item.co2eEstimado} t</p>
        </div>
      </div>

      <div className="flex items-center gap-3 mb-2 text-[11px] text-foreground-500">
        <span className="flex items-center gap-1"><i className="ri-map-pin-line text-xs"></i>{item.municipio}/{item.uf}</span>
        <span className={`badge ${item.temPlanoManejo ? "bg-primary-50 text-primary-700" : "bg-warning-50 text-warning-700"}`}>
          {item.temPlanoManejo ? "Com Plano de Manejo" : "Sem Plano de Manejo"}
        </span>
      </div>

      <p className="text-[11px] text-foreground-500 mb-3 truncate">{item.orgaoGestor}</p>

      <div className="flex gap-1.5">
        <button
          onClick={(e) => { e.stopPropagation(); onViewDetail(item); }}
          className="flex-1 text-xs py-1.5 rounded-btn border border-primary-200 text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer font-medium"
        >
          <i className="ri-information-line mr-1"></i>Detalhe
        </button>
        <button onClick={(e) => e.stopPropagation()} className="text-xs px-2.5 py-1.5 rounded-btn border border-accent-200 text-accent-700 hover:bg-accent-50 transition-colors cursor-pointer">
          <i className="ri-map-pin-line"></i>
        </button>
        <button onClick={(e) => e.stopPropagation()} className="text-xs px-2.5 py-1.5 rounded-btn border border-background-200 text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer">
          <i className="ri-file-text-line"></i>
        </button>
      </div>
    </div>
  );
}